import { createContext, useContext } from 'react';
import type { ShoppingBasketType } from '../../../common/types/shoppingBasketCoCo.js';
import type { Contact } from '../../../generated/api/contact.js';
import type { CustomerResponse } from '../../../generated/api/customerResponse.js';
import type { ProductOfferingsResponse } from '../../../generated/api/productOfferingsResponse.js';
import type { AuthenticatedUser } from '../../../public/site/authState.js';
import type { ShoppingBasketUpdateMethodsCoCo } from '../placeOrderTypesCoCo.js';

export interface CheckoutContextValue {
  basket: ShoppingBasketType;
  selectedProductOffers: ProductOfferingsResponse[];
  contacts: Contact[];
  refreshContacts: () => Promise<void>;
  mdmId: string;
  user: AuthenticatedUser;
  customerInfo: CustomerResponse;
  shoppingBasketUpdateMethods: ShoppingBasketUpdateMethodsCoCo;
  /** Set after createProductOrder succeeds */
  orderId: string | null;
  setOrderId: (id: string) => void;
  /** True for employee (EOE) checkout, where user and purpose-of-use fields are not collected */
  isEmployeeOrder?: boolean;
}

export const CheckoutContextCoCo = createContext<CheckoutContextValue | null>(null);

export const useCheckoutContext = (): CheckoutContextValue => {
  const ctx = useContext(CheckoutContextCoCo);
  if (!ctx) {
    throw new Error('useCheckoutContext must be used inside a CheckoutContextCoCo.Provider');
  }
  return ctx;
};
